module.exports = __webpack_public_path__ + "static/media/map-marker-check.ddcd6c73.svg";